export const capitalizeFirstLetter = (input) => input?.charAt(0).toUpperCase() + input?.slice(1);
export const convertToValidCssClass = (value) => value.replace(/[^a-zA-Z0-9-_]/gu, "");
export const normalizeBaseUrl = (baseUrl) => {
    let normalized = baseUrl;
    while (normalized.endsWith("/")) {
        normalized = normalized.slice(0, -1);
    }
    return normalized;
};
